import ConditionalField from '../../ReactFinalFormFields/RffConditionalWrapper';
import React, { useEffect } from 'react';
import RffReactSelectField from '../../ReactFinalFormFields/RffReactSelectField';
import RffDateField from '../../ReactFinalFormFields/RffDateField';
import { sub } from 'date-fns';
import { CONSULT_TYPES_WITH_SERVICES } from '../../../queries';

const VISIT_TYPE_OPTIONS = [
    {id:"new_visit", name: "New Visit"},
    {id:"follow_up_visit", name: "Follow-up Visit"},
]

const BookingDetailsPage = ({
    formValues,
    consultTypes,
    onConsultTypeChange,
    diseaseTypeOptions,
    clients,
    clientJobRoles,
    divisions,
    onClientChange,
    onDivisionChange,
    onJobRoleChange,
    siteOptions,
    medicalRoleOptions,
    serviceOptions,
}) => {
    return (
        <>
            <RffReactSelectField
                id="client"
                name="Client"
                options={clients}
                optional={false}
                onChange={onClientChange}
            />
            <RffReactSelectField
                id="consult_type"
                name="Reason for Visit"
                options={consultTypes}
                optional={false}
                onChange={onConsultTypeChange}
            />
            <RffReactSelectField
                id="visit_type"
                name="Type of Visit"
                defaultValue={"new_visit"}
                options={VISIT_TYPE_OPTIONS}
                optional={false}
            />
            <ConditionalField condition={(values) => divisions.length > 0} fields={['division']}>
                <RffReactSelectField
                    id="division"
                    name="Division"
                    options={divisions}
                    optional={false}
                    onChange={onDivisionChange}
                />
            </ConditionalField>
            <RffReactSelectField
                id="employment_site"
                name="Employment Site"
                options={siteOptions}
                optional={false}
            />
            <ConditionalField
                condition={(values) => CONSULT_TYPES_WITH_SERVICES.includes(values.consult_type)}
                fields={['tariff_code']}
            >
                <RffReactSelectField
                    id="tariff_code"
                    name="Service"
                    options={serviceOptions}
                    optional={false}
                />
            </ConditionalField>
            <ConditionalField
                condition={(values) =>
                    values.consult_type === 'occupational_health_consult_with_cof'
                }
                fields={['role_type']}
            >
                <RffReactSelectField
                    id="role_type"
                    name="Role Type"
                    options={[
                        { id: 'job_role', name: 'Job role' },
                        { id: 'medical_role', name: 'Medical role' },
                    ]}
                    optional={false}
                />
            </ConditionalField>

            <ConditionalField
                condition={(values) => values.role_type === 'job_role'}
                fields={['job_role']}
            >
                <RffReactSelectField
                    id="job_role"
                    name="Job Role"
                    options={clientJobRoles.map((jobRole) => {
                        return { id: jobRole.job_role_id, name: jobRole.job_role_name };
                    })}
                    optional={false}
                    onChange={onJobRoleChange}
                />
            </ConditionalField>

            <ConditionalField
                condition={(values) => values.role_type != null}
                fields={['role_type']}
            >
                <RffReactSelectField
                    isDisabled={formValues.role_type === 'job_role'}
                    id="medical_role"
                    name="Medical Role"
                    options={medicalRoleOptions}
                    optional={false}
                />
            </ConditionalField>

            <ConditionalField
                condition={(values) =>
                    ['chronic_care_consult', 'workplace_disease_consult'].includes(
                        values.consult_type
                    )
                }
                fields={['disease_type']}
            >
                <RffReactSelectField
                    id="disease_type"
                    name={
                        formValues.consult_type === 'chronic_care_consult'
                            ? 'Chronic Disease Type'
                            : 'Workplace Disease Type'
                    }
                    options={diseaseTypeOptions}
                    optional={false}
                />
            </ConditionalField>
            <RffDateField
                id="service_date"
                name="Service Date"
                optional={false}
                minDate={sub(new Date(), { months: 6 })}
                maxDate={new Date()}
                defaultValue={new Date()}
                isDisabled={
                    ![
                        'occupational_health_consult_with_cof',
                        'injury_on_duty_consult',
                        'primary_health_care_consult',
                        'traveler_medical_consult',
                        'care_review_consult',
                    ].includes(formValues.consult_type)
                }
            />
        </>
    );
};
export default BookingDetailsPage;
